import { useState, useCallback } from "react";

export const useHttpClient = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendRequest = useCallback(
    async (url, method = "GET", body = null, headers = {}) => {
      setIsLoading(true);
      try {
        if (!(body instanceof FormData)) {
          headers = {
            "Content-Type": "application/json",
            ...headers,
          };
        }

        const response = await fetch(url, {
          method,
          body,
          headers,
          credentials: "include",
        });

        let responseData;
        const contentType = response.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          responseData = await response.json();
        } else {
          responseData = await response.text();
        }

        if (!response.ok) {
          throw new Error(responseData.message || "Une erreur est survenue");
        }

        setIsLoading(false);
        return { ...responseData, ok: response.ok };
      } catch (err) {
        setIsLoading(false);
        setError(err.message);
        throw err;
      }
    },
    []
  );

  const clearError = () => {
    setError(null);
  };
  return { isLoading, error, sendRequest, clearError };
};
